import {useCallback} from "react";
import {useItemIsEnabled} from "../features";
import {useItemIsAllowed} from "../access";
import {VisibleItem} from "./VisibleItem";
import {VisibleItemPredicate} from "./VisibleItemPredicate";

export const useItemIsVisible = <
  T extends VisibleItem
>(): VisibleItemPredicate<T> => {
  const isEnabled = useItemIsEnabled<T>();
  const isAllowed = useItemIsAllowed<T>();
  return useCallback<VisibleItemPredicate<T>>(
    item => isEnabled(item) && isAllowed(item),
    [isEnabled, isAllowed]
  );
};
